import { render, staticRenderFns } from "./product-highlights.vue?vue&type=template&id=01777b31&"
import script from "./product-highlights.vue?vue&type=script&lang=js&"
export * from "./product-highlights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports